export const FEATURE_FLAGS = {
  zones_overlay_enabled: 'zones_overlay_enabled',
  map_tiles_enabled: 'map_tiles_enabled',
} as const;

// Derive the type from the enum values
export type FeatureFlagKey = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];

// Array of all feature flags for iteration
export const FEATURE_FLAG_LIST = Object.values(FEATURE_FLAGS);
